import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { FormControl } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import CloseIcon from "../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingBar from "../../../components/LoadingBar/LoadingBar.js";
import ModalCadastro from "../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import NewIcon from "../../../components/NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../../../components/SelectEmbarqueV2/SelectEmbarqueV2.js";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2.js";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController.js";
import TabelaRedux from "../../../contexts/Tabela.js";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import {
	cadastraEstadia,
	cadastraEstadiaGoogleStorage,
	deleteEstadiaPorId,
	deleteEstadiaStoragePorId,
	editaEstadiaPorId,
	getEstadia,
	getEstadiaGoogleStoragePorId,
	getEstadiaPorId,
} from "../../../services/ModuloGerenciador/Estadia.js";
import { getMotivoEstadia } from "../../../services/ModuloGerenciador/MotivoEstadia.js";
import { getStatusDiaria } from "../../../services/ModuloGerenciador/StatusDiaria.js";
import { getTipoVeiculo } from "../../../services/ModuloGerenciador/TipoVeiculo.js";
import "./Estadia.css";

const opcoes = [
	{
		opcao: "Diária de descarga",
		valor: 1,
	},
	{
		opcao: "Taxa de descarga",
		valor: 2,
	},
	{
		opcao: "Taxa devolução",
		valor: 3,
	},
];

const opcoesVeiculo = opcoes.map((data) => ({
	value: data.opcao,
	label: data.opcao,
	...data,
}));

const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
	{
		nomeColuna: "Usuário Responsável",
		field: "usuarioResponsavel",
	},
	{
		nomeColuna: "Elegível BRF",
		field: "elegivelBrf",
	},
];

const colunas = [
	{
		nomeColuna: "Load",
		field: "load",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Data/Hora Chegada",
		field: "dataHoraChegadaEmbarque",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Data/Hora Saida",
		field: "dataHoraEmbarcado",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Data/Hora Agendamento",
		field: "dataHoraEntregue",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Placa",
		field: "veiculoEmbarque",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
		objetoEmb: "true",
	},
	{
		nomeColuna: "Status Diária",
		field: "statusEmbarque",
		objetoEmb: "true",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
		objetoEmb: "true",
	},
];

const labelVeiculo = (data) => <div>{data.opcao}</div>;

function Estadia(props) {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const estiloVeiculo = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabelaEstadia, setDadosTabelaEstadia] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [idEmbarque, setIdEmbarque] = useState(null);

	const [dadosEmb, setDadosEmb] = useState(null);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const [listaStatus, setListaStatus] = useState([]);

	const buscarStatusDiaria = async () => {
		setLoadingSelectStatusDiaria(true);
		await getStatusDiaria(profile?.token)
			.then((result) => {
				setListaStatus(result.data);
				setLoadingSelectStatusDiaria(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const [listaMotivo, setListaMotivo] = useState([]);

	const buscarMotivoEstadia = async () => {
		setLoadingSelectMotivoEstadia(true);
		await getMotivoEstadia(profile?.token)
			.then((result) => {
				setListaMotivo(result.data);
				setLoadingSelectMotivoEstadia(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const [listaTipoVeiculo, setListaTipoVeiculo] = useState([]);

	const title = useMemo(() => {
		if (editando) return "Detalhes de Estadia";
		if (telaCadastro) return "Cadastro de Estadia";
		return "Estadia";
	}, [editando, telaCadastro]);

	const buscarTipoVeiculo = async () => {
		setLoadingSelectTipoVeiculo(true);
		await getTipoVeiculo(profile?.token)
			.then((result) => {
				setListaTipoVeiculo(result.data);
				setLoadingSelectTipoVeiculo(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoadingSelectTipoVeiculo(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarEstadia = async () => {
		setLoading(true);
		await getEstadia(profile?.token)
			.then((result) => {
				setDadosTabelaEstadia(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const salvarEstadiaStorage = async (id) => {
		if (!arquivos || arquivos.length === 0) {
			setLoading(false);
			buscarEstadia();
			setDadosRequestControllerRedux("Fechar Modal Estadia");
			setTabelaRedux({});
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
			setValues({});
			setDadosEmb(null);
			setArquivos([]);
			setValuesSelect({});
			setTelaCadastro(false);
			return;
		}

		setLoading(true);
		try {
			for (const arquivo of arquivos) {
				if (!arquivo.url) {
					const formData = new FormData();
					formData.append("formFile", arquivo.arquivo);

					const result = await cadastraEstadiaGoogleStorage(
						formData,
						id,
						profile?.token
					);

					if (result.status !== 200) {
						throw new Error(result.data || "Erro ao cadastrar o arquivo");
					}
				}
			}

			setDadosRequestControllerRedux("Fechar Modal Documentacao");
			setTextoSucesso("Todos os arquivos foram cadastrados com sucesso!");
			setOpenToastSucesso(true);
		} catch (error) {
			if (error.response && typeof error.response.data === "string") {
				setTextoErro(error.response.data);
			} else {
				setTextoErro(
					"Ocorreu um erro inesperado, volte e tente novamente. Caso o problema persista, entre em contato com o suporte."
				);
			}
			setOpenToastErro(true);
		} finally {
			setLoading(false);
			buscarEstadia();
			setDadosRequestControllerRedux("Fechar Modal Estadia");
			setTabelaRedux({});
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
			setValues({});
			setDadosEmb(null);
			setArquivos([]);
			setValuesSelect({});
			setTelaCadastro(false);
		}
		setLoading(false);
	};

	const cadastrar = async () => {
		setLoading(true);
		await cadastraEstadia(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					salvarEstadiaStorage(result.data.id);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const cadastrarEmbarque = async (idEmbarque) => {
		const valor = {
			embarqueId: idEmbarque,
		};
		setLoading(true);
		await cadastraEstadia(valor, profile?.token)
			.then((result) => {
				setValues(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const editar = async () => {
		setLoading(true);
		await editaEstadiaPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					salvarEstadiaStorage(result.data.id);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	};

	const buscarEstadiaStoragePorId = async () => {
		setLoading(true);
		await getEstadiaGoogleStoragePorId(tabelaRedux.row.id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await preencherDadosEditando(result);
						setValues(result.data);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	};

	const buscarEstadiaPorId = async () => {
		setLoading(true);
		await getEstadiaPorId(tabelaRedux?.row?.id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await preencherDadosEditando(result);
						if (result.data.estadiaGoogleStorages) {
							const arquivos = result.data.estadiaGoogleStorages.map(
								(item) => ({
									id: item.id,
									url: item.googleStorage.documentoUrl,
									name: item.googleStorage.documentoUrl.split("/").pop(), // Extrai o nome do arquivo do URL
								})
							);
							setArquivos(arquivos); // Atualiza o estado
						}
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarEstadiaPorIdModal = async (id) => {
		setLoading(true);
		await getEstadiaPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarEstadiaPorId = async () => {
		setLoading(true);
		await deleteEstadiaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarEstadia();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (profile?.token) {
			setValidator((current) => ({ ...current, nome: "false" }));
		}
	}, [profile?.token]);

	useEffect(() => {
		if (!!idEmbarque) {
			setValues((current) => ({ ...current, embarqueId: idEmbarque }));
			cadastrarEmbarque(idEmbarque);
		}
	}, [idEmbarque]);

	useEffect(() => {
		if (profile?.token) {
			if (props.telaCadastro === true) {
				setTelaCadastro(true);
			}
			if (props.idAtual) {
				buscarEstadiaPorIdModal(props.idAtual);
			}
			if (editando) {
				buscarEstadiaPorId();
			}
		}
	}, [profile?.token, props.telaCadastro, props.idAtual, editando]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Estadia"));
			buscarEstadia();
			buscarStatusDiaria();
			buscarMotivoEstadia();
			buscarTipoVeiculo();
		}
	}, [profile?.token]);

	const [dadosTabelaCopiaFiltro, setDadosTabelaCopiaFiltro] = useState([]);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const [loadingSelectStatusDiaria, setLoadingSelectStatusDiaria] =
		useState(false);

	const [openCadastroStatusDiaria, setOpenCadastroStatusDiaria] =
		useState(false);

	const handleCloseCadastroStatusDiaria = (value) => {
		if (idAtual) {
			setOpenCadastroStatusDiaria(false);
		} else {
			setLoadingSelectStatusDiaria(true);
			buscarStatusDiaria();
			setOpenCadastroStatusDiaria(false);
		}
	};

	const [loadingSelectMotivoEstadia, setLoadingSelectMotivoEstadia] =
		useState(false);

	const [openCadastroMotivoEstadia, setOpenCadastroMotivoEstadia] =
		useState(false);

	const handleCloseCadastroMotivoEstadia = (value) => {
		if (idAtual) {
			setOpenCadastroMotivoEstadia(false);
		} else {
			setLoadingSelectMotivoEstadia(true);
			buscarMotivoEstadia();
			setOpenCadastroMotivoEstadia(false);
		}
	};

	const [arquivos, setArquivos] = useState([]);

	const [loadingSelectTipoVeiculo, setLoadingSelectTipoVeiculo] =
		useState(false);

	const [openCadastroTipoVeiculo, setOpenCadastroTipoVeiculo] = useState(false);

	const handleCloseCadastroTipoVeiculo = (value) => {
		if (idAtual) {
			setOpenCadastroTipoVeiculo(false);
		} else {
			setLoadingSelectTipoVeiculo(true);
			buscarTipoVeiculo();
			setOpenCadastroTipoVeiculo(false);
		}
	};

	const [valuesSelect, setValuesSelect] = useState([]);

	const [disable, setDisable] = useState(false);

	const [idAtual, setIdAtual] = useState();

	const clearStatusDiaria = () => {
		setValuesSelect((current) => ({ ...current, statusDiariaId: "" }));
		setValues((current) => ({ ...current, statusDiariaId: null }));
		setValidator((current) => ({ ...current, statusDiariaId: "false" }));
	};

	const clearMotivoEstadia = () => {
		setValuesSelect((current) => ({ ...current, motivoEstadiaId: "" }));
		setValues((current) => ({ ...current, motivoEstadiaId: null }));
		setValidator((current) => ({ ...current, motivoEstadiaId: "false" }));
	};

	const clearTipoVeiculo = () => {
		setValuesSelect((current) => ({ ...current, tipoVeiculoId: "" }));
		setValues((current) => ({ ...current, tipoVeiculoId: null }));
		setValidator((current) => ({ ...current, tipoVeiculoId: "false" }));
	};

	const preencherDadosEditando = async (result) => {
		setDadosEmb(result.data.embarque);
		let tipoEstadia;
		if (result.data.tipoEstadia === 1) {
			tipoEstadia = "Diária de descarga";
		} else if (result.data.tipoEstadia === 2) {
			tipoEstadia = "Taxa de descarga";
		} else if (result.data.tipoEstadia === 3) {
			tipoEstadia = "Taxa devolução";
		}
		const tipoEstadiaSelecionado = opcoesVeiculo.find(
			(option) => option.value === tipoEstadia
		);
		if (tipoEstadiaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoEstadia: tipoEstadiaSelecionado,
			}));
		}

		const statusSelecionado = listaStatus.find(
			(option) => option.id === result.data.statusDiariaId
		);
		if (statusSelecionado) {
			setValuesSelect((current) => ({
				...current,
				statusDiariaId: {
					value: statusSelecionado.status,
					label: statusSelecionado.status,
					id: statusSelecionado.id,
				},
			}));
		}
		const motivoSelecionado = listaMotivo.find(
			(option) => option.id === result.data.motivoEstadiaId
		);
		if (motivoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				motivoEstadiaId: {
					value: motivoSelecionado.motivo,
					label: motivoSelecionado.motivo,
					id: motivoSelecionado.id,
				},
			}));
		}
		const tipoVeiculoSelecionado = listaTipoVeiculo.find(
			(option) => option.id === result.data.tipoVeiculoId
		);
		if (tipoVeiculoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoVeiculoId: {
					value: tipoVeiculoSelecionado.nome,
					label: tipoVeiculoSelecionado.nome,
					id: tipoVeiculoSelecionado.id,
				},
			}));
		}
	};

	const deletarStorage = async (id) => {
		await deleteEstadiaStoragePorId(id, profile?.token)
			.then((result) => {})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const removeImg = (item, index) => {
		if (item.id) {
			deletarStorage(item.id);
		}

		setArquivos((prevArquivos) => prevArquivos.filter((_, i) => i !== index));
	};

	const isLoading = useMemo(() => {
		return loading || !profile?.token;
	}, [loading, profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="telaEstadia">
						<div className="content-container">
							<Separator size="xl" />
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="id"
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.Estadia}
								setIdEmbarque={setIdEmbarque}
								dados={dadosTabelaEstadia}
								isLoading={isLoading}
							/>
						</div>
						<div className="footer-container">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Procurar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="telaCadastroEstadia" scroll>
						<div className="content-container-scrollable">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Dados de Estadia / "}</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Estadia"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Estadia"}</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													buscarEstadia();
													setValues({});
													setDadosEmb(null);
													setArquivos([]);
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
													setValuesSelect({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="outer-wrapper-diaria-veiculo">
												<div
													className="table-wrapper-diaria-veiculo"
													id="tableWrapper"
												>
													<table className="tabela-diaria-veiculo">
														<thead>
															<tr>
																{colunas.map((coluna, index) => (
																	<th key={index} className="th-diaria-estadia">
																		{coluna.nomeColuna}
																	</th>
																))}
															</tr>
														</thead>
														<tbody>
															<tr>
																<th className="th-diaria-estadia">
																	{dadosEmb?.load}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.dataHoraChegadaEmbarque
																		? new Date(
																				dadosEmb.dataHoraChegadaEmbarque
																		  ).toLocaleDateString("pt-BR", {
																				month: "numeric",
																				day: "numeric",
																				hour: "numeric",
																				minute: "numeric",
																		  })
																		: ""}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.dataHoraEmbarcado
																		? new Date(
																				dadosEmb.dataHoraEmbarcado
																		  ).toLocaleDateString("pt-BR", {
																				month: "numeric",
																				day: "numeric",
																				hour: "numeric",
																				minute: "numeric",
																		  })
																		: ""}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.dataHoraEntregue
																		? new Date(
																				dadosEmb.dataHoraEntregue
																		  ).toLocaleDateString("pt-BR", {
																				month: "numeric",
																				day: "numeric",
																				hour: "numeric",
																				minute: "numeric",
																		  })
																		: ""}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.veiculo?.caminhao?.placa}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.cliente}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.unidEmbarque}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.statusEmbarque}
																</th>
																<th className="th-diaria-estadia">
																	{dadosEmb?.cte}
																</th>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												{loadingSelectStatusDiaria ? (
													<LoadingBar />
												) : (
													<div className="coluna-emb">
														<div>
															<p
																className="input-label-emb"
																htmlFor="descricao"
															>
																Status Diária:
															</p>
															<SelectEmbarqueV2
																classeCss={250}
																onChange={(e) => {
																	setValuesSelect((current) => ({
																		...current,
																		statusDiariaId: e,
																	}));
																	setValues((current) => ({
																		...current,
																		statusDiariaId: e.id,
																	}));
																	setValidator((current) => ({
																		...current,
																		statusDiariaId: "true",
																	}));
																}}
																onClick={(e) => {
																	e.stopPropagation();
																	setDisable(true);
																	setOpenCadastroStatusDiaria(true);
																}}
																clearSelection={clearStatusDiaria}
																onInfoIconClick={setIdAtual}
																id="id"
																grande={true}
																value={valuesSelect.statusDiariaId || ""}
																titulo="Grupo Cliente"
																dadosSelect={listaStatus}
																referenciaId="status"
																referenciaItem="status"
															/>
														</div>
														<NewIcon
															onClick={(e) => {
																setOpenCadastroStatusDiaria(true);
																setIdAtual(null);
																setDisable(false);
															}}
														/>
													</div>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												{loadingSelectMotivoEstadia ? (
													<LoadingBar />
												) : (
													<div className="coluna-emb">
														<div>
															<p
																className="input-label-emb"
																htmlFor="descricao"
															>
																Motivo Estadia:
															</p>
															<SelectEmbarqueV2
																classeCss={250}
																onChange={(e) => {
																	setValuesSelect((current) => ({
																		...current,
																		motivoEstadiaId: e,
																	}));
																	setValues((current) => ({
																		...current,
																		motivoEstadiaId: e.id,
																	}));
																	setValidator((current) => ({
																		...current,
																		motivoEstadiaId: "true",
																	}));
																}}
																onClick={(e) => {
																	e.stopPropagation();
																	setDisable(true);
																	setOpenCadastroMotivoEstadia(true);
																}}
																clearSelection={clearMotivoEstadia}
																onInfoIconClick={setIdAtual}
																id="id"
																grande={true}
																value={valuesSelect.motivoEstadiaId || ""}
																titulo="Grupo Cliente"
																dadosSelect={listaMotivo}
																referenciaId="motivo"
																referenciaItem="motivo"
															/>
														</div>
														<NewIcon
															onClick={(e) => {
																setOpenCadastroMotivoEstadia(true);
																setIdAtual(null);
																setDisable(false);
															}}
														/>
													</div>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												{loadingSelectTipoVeiculo ? (
													<LoadingBar />
												) : (
													<div className="coluna-emb">
														<div>
															<p
																className="input-label-emb"
																htmlFor="descricao"
															>
																Tipo Veículo:
															</p>
															<SelectEmbarqueV2
																classeCss={250}
																onChange={(e) => {
																	setValuesSelect((current) => ({
																		...current,
																		tipoVeiculoId: e,
																	}));
																	setValues((current) => ({
																		...current,
																		tipoVeiculoId: e.id,
																	}));
																	setValidator((current) => ({
																		...current,
																		tipoVeiculoId: "true",
																	}));
																}}
																onClick={(e) => {
																	e.stopPropagation();
																	setDisable(true);
																	setOpenCadastroTipoVeiculo(true);
																}}
																clearSelection={clearTipoVeiculo}
																onInfoIconClick={setIdAtual}
																id="id"
																grande={true}
																value={valuesSelect.tipoVeiculoId || ""}
																titulo="Grupo Cliente"
																dadosSelect={listaTipoVeiculo}
																referenciaId="nome"
																referenciaItem="nome"
															/>
														</div>
														<NewIcon
															onClick={(e) => {
																setOpenCadastroTipoVeiculo(true);
																setIdAtual(null);
																setDisable(false);
															}}
														/>
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Daste:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															daste: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															daste: "true",
														}));
													}}
													value={values.daste || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Observação:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															observacao: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															observacao: "true",
														}));
													}}
													value={values.observacao || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													CTE:
												</p>
												<input
													type="text"
													maxLength="5"
													placeholder="00000"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														let valor = e.target.value;
														valor = valor.replace(/\D/g, "");
														setValues((current) => ({
															...current,
															cteComplementar: valor,
														}));
													}}
													value={values.cteComplementar || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Tipo Estadia:
												</p>
												<FormControl sx={{ width: 265 }}>
													<Select
														value={valuesSelect.tipoEstadia || ""}
														options={opcoesVeiculo}
														formatOptionLabel={labelVeiculo}
														styles={estiloVeiculo}
														placeholder="Selecione"
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setValues((current) => ({
																	...current,
																	tipoEstadia: selectedOption.valor,
																}));
																setValuesSelect((current) => ({
																	...current,
																	tipoEstadia: selectedOption,
																}));
																setValidator((current) => ({
																	...current,
																	tipoEstadia: "true",
																}));
															}
														}}
													/>
												</FormControl>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Frete Empresa:
												</p>
												<input
													type="number"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															freteEmpresa: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															freteEmpresa: "true",
														}));
													}}
													value={values.freteEmpresa || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Frete Motorista:
												</p>
												<input
													type="number"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															freteMotorista: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															freteMotorista: "true",
														}));
													}}
													value={values.freteMotorista || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div
											className="coluna-emb"
											style={{ alignItems: "flex-start", gap: 10 }}
										>
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Anexar Arquivos:
												</p>
												<input
													type="file"
													className="input-emb"
													style={{ width: "270px" }}
													multiple
													onChange={(e) => {
														const arquivosSelecionados = Array.from(
															e.target.files
														);
														const arquivosComPreview = arquivosSelecionados.map(
															(arquivo) => {
																const url = URL.createObjectURL(arquivo);
																return { arquivo, preview: url };
															}
														);
														setArquivos((prevArquivos) => [
															...(prevArquivos || []),
															...arquivosComPreview,
														]);
														setValidator((current) => ({
															...current,
															arquivos: "true",
														}));
													}}
													disabled={props.desabilitar}
												/>
											</div>
											{arquivos && arquivos.length > 0 && (
												<div className="lista-arquivos">
													<p className="input-label-emb">Arquivos Anexados:</p>
													<ul>
														{arquivos.map((item, index) => (
															<li key={index} className="nome-arquivo">
																{item.preview ? (
																	<img
																		src={item.preview}
																		alt={
																			item.arquivo?.name || `Arquivo ${index}`
																		}
																		style={{
																			width: "100px",
																			height: "100px",
																			marginRight: "10px",
																			objectFit: "cover",
																			borderRadius: "5px",
																		}}
																	/>
																) : item.url.includes("pdf") ? (
																	<iframe
																		src={item.url}
																		className="preview-pdf"
																		title={`${item.name} Preview`}
																	></iframe>
																) : (
																	<img
																		src={item.url}
																		alt=""
																		style={{
																			width: "100px",
																			height: "100px",
																			marginRight: "10px",
																			objectFit: "cover",
																			borderRadius: "5px",
																		}}
																	/>
																)}
																{item && item.arquivo && item.arquivo.name ? (
																	<>
																		{item.arquivo.name.length > 10
																			? `${item.arquivo.name.substring(
																					0,
																					10
																			  )}...`
																			: item.arquivo.name}
																		<div className="grid-item-entrega">
																			<Tooltip title={<p>Visualizar</p>}>
																				<VisibilityIcon
																					className="trash-v2"
																					onClick={() =>
																						window.open(item.url, "_blank")
																					}
																				></VisibilityIcon>
																			</Tooltip>
																			<Tooltip title={<p>Deletar</p>}>
																				<DeleteIcon
																					className="trash-v2"
																					onClick={() => removeImg(item, index)}
																				></DeleteIcon>
																			</Tooltip>
																		</div>
																	</>
																) : (
																	<>
																		{item.name.length > 10
																			? `${item.name.substring(0, 10)}...`
																			: item.name}
																		<div className="grid-item-entrega">
																			<Tooltip title={<p>Visualizar</p>}>
																				<VisibilityIcon
																					className="trash-v2"
																					onClick={() =>
																						window.open(item.url, "_blank")
																					}
																				></VisibilityIcon>
																			</Tooltip>
																			<Tooltip title={<p>Deletar</p>}>
																				<DeleteIcon
																					className="trash-v2"
																					onClick={() => removeImg(item, index)}
																				></DeleteIcon>
																			</Tooltip>
																		</div>
																	</>
																)}
															</li>
														))}
													</ul>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
							<div className="footer-container">
								{editando ? (
									<CustomButtonV2
										classCss="custom-button-cadastrar"
										classText="button-texto-cadastrar"
										icone="iconeSave"
										titulo="Salvar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											editar();
											setTelaCadastro(false);
											setEditando(false);
											setValues({});
											setArquivos([]);
											setValuesSelect({});
											setDadosEmb(null);
										}}
									/>
								) : (
									<>
										{!props.desabilitar ? (
											props.botaoCadastrar ? (
												<CustomButtonV2
													classCss="custom-button-cadastrar"
													classText="button-texto-cadastrar"
													icone="iconeSave"
													titulo="Salvar"
													cor="#0946B8"
													valor={values}
													onClick={() => {
														editar();
													}}
												/>
											) : (
												<CustomButtonV2
													classCss="custom-button-cadastrar"
													classText="button-texto-cadastrar"
													icone="iconeSave"
													titulo="Salvar"
													cor="#0946B8"
													valor={values}
													onClick={() => {
														editar();
													}}
												/>
											)
										) : (
											<></>
										)}
									</>
								)}
								{props.botaoVoltar ? (
									<></>
								) : (
									<CustomButtonV2
										classCss="custom-button-cancelar"
										classText="button-texto-cancelar"
										titulo="Cancelar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											buscarEstadia();
											setValues({});
											setDadosEmb(null);
											setArquivos([]);
											setValuesSelect({});
											setTelaCadastro(false);
											setEditando(false);
											setTabelaRedux({});
										}}
									/>
								)}
							</div>
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<ModalConfirmacao
				titulo="Deletar"
				texto="Deseja Deletar?"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={open}
				onClose={handleClose}
				onClick={deletarEstadiaPorId}
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openUsuario}
				onClose={handleCloseUsuario}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroStatusDiaria="sim"
				open={openCadastroStatusDiaria}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroStatusDiaria}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroMotivoEstadia="sim"
				open={openCadastroMotivoEstadia}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroMotivoEstadia}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroTipoVeiculo="sim"
				open={openCadastroTipoVeiculo}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroTipoVeiculo}
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default Estadia;
